import {
  DEFAULT_LOCALE,
  getLocaleFromPathname,
  normalizeLocale,
} from "./localeRouting";

export const SHOPIFY_CHECKOUT_LOCALE_MAP = Object.freeze({
  en: "en",
  zh: "zh-cn",
  "zh-TW": "zh-tw",
  fr: "fr",
  es: "es",
  ar: "ar",
  ja: "ja",
  ru: "ru",
  ko: "ko",
  pt: "pt",
  "pt-BR": "pt-br",
  it: "it",
  de: "de",
  hi: "hi",
  mn: "mn",
  th: "th",
  uk: "uk",
  vi: "vi",
  id: "id",
  tl: "tl",
  bn: "bn",
});

export function getShopifyCheckoutLocale(locale = DEFAULT_LOCALE) {
  const normalizedLocale = normalizeLocale(locale);
  return SHOPIFY_CHECKOUT_LOCALE_MAP[normalizedLocale] || "";
}

export function getShopifyCheckoutLocaleFromPathname(pathname = "/") {
  const routeLocale = getLocaleFromPathname(pathname) || DEFAULT_LOCALE;
  return getShopifyCheckoutLocale(routeLocale);
}

export function appendShopifyCheckoutLocale(urlLike, pathname = "/") {
  const url = new URL(String(urlLike));
  const locale = getShopifyCheckoutLocaleFromPathname(pathname);

  if (locale) {
    url.searchParams.set("locale", locale);
  }

  return url;
}
